import { Typography } from "@mui/material";

import type { GroupedRecommendation } from "@app/analytics/types";
import * as RecommendationUtils from "@app/analytics/utils/recommendationUtils";
import { ELLIPSIS_SX } from "@app/common/styles";

import RecurringMeetingBadge from "@rui/RecurringMeetingBadge";
import { Row } from "@rui/Stack";

import { OuterContainer, InnerContainer } from "./styles";
import NonRecurringMeetingBadge from "../NonRecurringMeetingBadge";
import RecommendationActionsDropdownMenu from "../RecommendationActionsDropdownMenu";
import RecommendationCountChip from "../RecommendationCountChip";

interface RecommendationSummaryProps {
  onClick: () => void;
  recommendation: GroupedRecommendation;
  selected: boolean;
  onAcceptAll: (rec: GroupedRecommendation) => void;
  onRejectAll: (rec: GroupedRecommendation) => void;
}

const RecommendationSummaryMeetingInfo = ({
  isRecurring,
  meetingSchedule,
}: Pick<GroupedRecommendation, "isRecurring" | "meetingSchedule">) => (
  <>
    {isRecurring ? (
      <RecurringMeetingBadge size="12px" />
    ) : (
      <NonRecurringMeetingBadge size="12px" />
    )}
    <Typography variant="labelReg" sx={{ color: "shades.neutral.800" }}>
      {RecommendationUtils.parseMeetingSchedule(meetingSchedule)}
    </Typography>
  </>
);

const RecommendationSummary = ({
  onClick,
  recommendation,
  selected,
  onAcceptAll,
  onRejectAll,
}: RecommendationSummaryProps) => {
  const handleAcceptAll = () => {
    onAcceptAll(recommendation);
  };
  const handleRejectAll = () => {
    onRejectAll(recommendation);
  };

  return (
    <OuterContainer>
      <InnerContainer spacing={0.5} onClick={onClick} selected={selected}>
        <Row spacing={1} variant="apart">
          <Typography
            sx={{ color: "shades.neutral.800", ...ELLIPSIS_SX }}
            title={recommendation.meetingName}
          >
            {recommendation.meetingName}
          </Typography>
          <Row spacing={1} variant="right">
            <RecommendationCountChip color="neutral">
              {recommendation.recommendations.length}
            </RecommendationCountChip>
            <RecommendationActionsDropdownMenu
              onAcceptAll={handleAcceptAll}
              onRejectAll={handleRejectAll}
            />
          </Row>
        </Row>
        <Row variant="left" spacing={1}>
          {RecommendationUtils.isGroupedCoachingRecommendation(
            recommendation
          ) ? (
            <Typography variant="labelMed" color="shades.neutral.600">
              Your Speaker Coach found opportunties to improve! Take a look.
            </Typography>
          ) : (
            <RecommendationSummaryMeetingInfo
              isRecurring={recommendation.isRecurring}
              meetingSchedule={recommendation.meetingSchedule}
            />
          )}
        </Row>
      </InnerContainer>
    </OuterContainer>
  );
};

export default RecommendationSummary;
